import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import isEmpty from "lodash.isempty";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import { add_question } from "../../../redux/actions/questionActions";

import languageConfig from "../../../config/languageConfig";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const history = createBrowserHistory();
class Question extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertMessage: "",
      msgType: "",
      question: "",
      questionError: "",
      dealID: "",
      show: "",
      hover: false,
      default_lang: (cookies.get('default_lang') ? cookies.get('default_lang') : 'en')
      //default_lang: (cookies.get('default_lang') ? cookies.get('default_lang') : 'en'),
    };
    this.validate = this.validate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }

  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });    
  }

  handleChange(e) {
    e.preventDefault();
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
    this.setState({ disabled: false });
  }

  validate = () => {
    let isError = false;
    const errors = {};
    if (this.state.question.length === 0) {
      isError = true;
      this.setState({ questionError: "red" });
    }
    return isError;
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleSubmit(e) {
    this.handleShow();
    e.preventDefault();
    const err = this.validate();
    if (!err) {
      const postData = {
        question: this.state.question,
        dealID: this.state.dealID
      };
      this.props.add_question(postData);
    }
  }

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      this.setState({default_lang: siteData.default_lang,});
    }
    this.setState({ dealID: this.props.dealID });
  }
  componentWillReceiveProps(nextProps) {
    if(nextProps.default_lang){
      this.setState({default_lang: nextProps.default_lang});
    }
    if (
      this.props.addedQuestionResponse !== nextProps.addedQuestionResponse &&
      !isEmpty(nextProps.addedQuestionResponse)
    ) {
      if (nextProps.addedQuestionResponse.response === "success") {
        this.setState({ questionError: "", question: "" });
        this.handleShow();
        this.props.renderAlert(
          "success",
          nextProps.addedQuestionResponse.message
        );
        window.scrollTo(0, 0);
      }
    }
    if (this.props.message !== nextProps.message) {
      this.setState({ alertMessage: nextProps.message });
      window.scrollTo(0, 0);
    }
    if (this.props.alertType !== nextProps.alertType) {
      this.setState({ msgType: nextProps.alertType });
    }
    if (this.props.error !== nextProps.error && nextProps.error !== "") {
      this.handleShow();
      this.props.renderAlert("warning", nextProps.error);
      window.scrollTo(0, 0);
    }
  }

  setDefaultLanguage = (lang) => {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    siteData.default_lang = lang; 
    localStorage.setItem('siteDDBStatus', JSON.stringify(siteData));
    this.setState({
        default_lang: lang
    });
    
    let d = new Date();
    d.setTime(d.getTime() + 480 * 60 * 1000);
    cookies.set("default_lang", lang, { path: "/", expires: d });

    this.props.setLanguage(lang);
    this.props.getSiteStatus(lang); 
    this.props.getMenuList({page:1, lang: lang, cityID: siteData.default_city});
    if(cookies.get('token')){
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: lang});
      this.props.getCartDetail({'userKey':cookies.get('token'), lang: lang});
    }
  }

  handlePageChange = page => {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){ 
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
        });
      }
    }

    this.setState({
      currentPage: page,
      cartTotal: 0
    });
    if(cookies.get('token')){
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
      this.props.getCartDetail({'userKey':cookies.get('token'), lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
    }
  };

  componentDidMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    let disableSubscriptionPopup = (localStorage.getItem('disableSubscriptionPopup')) ? localStorage.getItem('disableSubscriptionPopup') : false;
    let accessibleCities = (localStorage.getItem('accessibleCities')) ? JSON.parse(localStorage.getItem('accessibleCities')) : [];

    // alert("Footer default_lang"+siteData.default_lang);
    // alert("Footer multi_lang"+siteData.multi_lang);
    // alert("Footer lang"+siteData.lang);

    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){
        this.setState({
    multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
  
        });
      }
    }

    if(siteData){
      this.setState({ fontFamilies: siteData.font_families });
    }

    if(siteData){
      this.setState({twitterPage: siteData.twitterPage,facebookPage: siteData.facebookPage, siteName: siteData.siteName, youtube_link: siteData.youtube_link, insta_link: siteData.insta_link});
      let showCityPasswordFrom = true 
      if(siteData.password_protect == 'active' && this.props.match.path != '/login' && this.props.match.path != '/register/') {
        const cityPasswordIndx = siteData.city_passwords.findIndex(x => x.cityID === siteData.default_city);
        const cityIndx = accessibleCities.findIndex(x => x.cityID === siteData.default_city);
        
        if((cityIndx >= 0 && accessibleCities[cityIndx].status == true) || cityPasswordIndx == -1 ) {
          showCityPasswordFrom = false;
        }
        this.setState({ showCityPasswordFrom: showCityPasswordFrom });
      }
      if(!(siteData.password_protect == 'active' && showCityPasswordFrom) && siteData.popup_subscrbe == 'enable' && this.props.match.path == '/' && disableSubscriptionPopup == false){
        this.setState({ showSubscriptionFrom: true });
      }      
    }

    if(this.props.themeData){
      this.setState({
        themeData: this.props.themeData
      });

      if(this.props.themeData.menu_bar){
        this.setState({
          menuBgStyles: {
            backgroundColor: this.props.themeData.menu_bar.menu_bar_color
          }
        })
      }else{
        this.setState({
          menuBgStyles: {
            backgroundColor: ''
          }
        })
      }
      if(this.props.themeData.footer){
        this.setState({
          footerBgStyles: {
            'backgroundColor': this.props.themeData.footer.footer_color,
          },
          footerTextStyles: {
            'color': this.props.themeData.footer.footer_text_color,
          },
          footer_social_link_color: {
            'color' : this.props.themeData.footer.footer_social_link_color,
          }
          
        });
      }else{
        this.setState({
          footerBgStyles: {
            'backgroundColor': '',
          },
          footerTextStyles: {
            'color': '',
          },
          footer_social_link_color: {
            'color' : '',
          }
          
        });
      }

      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }else{
        this.setState({
          button_color: '',
          mouseover_color: '',
        });
      }

    }
  }

  render() {
    return (
      <div>
        {/*this.state.show &&
          this.state.alertMessage !== "" &&
          this.state.msgType && (
            <div className="col-lg-12 col-xs-12 col-md-12 col-sm-12">
              <Alert
                bsStyle={this.state.msgType}
                onDismiss={this.handleDismiss}
              >
                <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
              </Alert>
            </div>
          )*/}
        <form onSubmit={this.handleSubmit}>
          <Row>
            <Col md={12} xs={12}>
              <FormGroup controlId="formQuestion">
                <ControlLabel>{languageConfig[this.state.default_lang].question}</ControlLabel>
                <FormControl
                  value={this.state.question}
                  componentClass="textarea"
                  onChange={this.handleChange}
                  name="question"
                  placeholder={languageConfig[this.state.default_lang].ask_your_question}
                  style={{ borderColor: this.state.questionError }}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row className="BtnRow">
            <Col md={12} xs={12}>
              <Button
                bsStyle="danger"
                disabled={this.props.sendingQustion}
                type="submit"
                className="pull-left"
                id="saveButton"
                style={{backgroundColor: (this.state.hover && this.state.hoverID == "question") ? this.state.mouseover_color : this.state.button_color}}
                data-id = {"question"}
                onMouseEnter={this.hoverOn} 
                onMouseLeave={this.hoverOff}
              >
                {languageConfig[this.state.default_lang].submit_question}
              </Button>
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}

Question.propTypes = {
  add_question: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  sendingQustion: state.questionReducer.sendingQustion,
  addedQuestionResponse: state.questionReducer.addedQuestionResponse,
  message: state.alertsReducer.message,
  alertType: state.alertsReducer.alertType,
  error: state.questionReducer.error
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, { add_question, clearAlert, renderAlert })
)(Question);



// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/Question.js